import React from 'react'
import ManagdLogotype from '../assets/managd-logotype.svg'

const ASPECT_RATIO = 676.8 / 156.36

const BrandLogo = ({ height = 22, className, style }) => (
    <span
        role='img'
        aria-label='managd.'
        className={className}
        style={{
            display: 'inline-block',
            flexShrink: 0,
            height,
            width: height * ASPECT_RATIO,
            backgroundColor: 'var(--brand)',
            maskImage: `url(${ManagdLogotype})`,
            WebkitMaskImage: `url(${ManagdLogotype})`,
            maskRepeat: 'no-repeat',
            WebkitMaskRepeat: 'no-repeat',
            maskSize: 'contain',
            WebkitMaskSize: 'contain',
            maskPosition: 'center',
            WebkitMaskPosition: 'center',
            ...style,
        }}
    />
)

export default BrandLogo
